import { GetProjectsFullList } from '@/connection/projects/get-projects-list';
import { serializeError } from '@/store/utils/serialize-error';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectsReducerCreator } from '../types';

const loadProjectsListReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const projectsList = await GetProjectsFullList(channel);
        return projectsList;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      pending: (state) => {
        state.projectsListLoading = true;
      },
      rejected: (state) => {
        state.projectsListError = true;
        toastTrigger('There was an error loading projects. Please refresh the page.', {
          type: 'error',
        });
      },
      fulfilled: (state, action) => {
        state.projectsList = action.payload;
        state.projectsListError = false;
      },
      settled: (state) => {
        state.projectsListLoading = false;
      },
    }
  );
};

export default loadProjectsListReducer;
